package br.com.htms.inspeccaocampo.util

object Base64Codec {
    private val TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"

    fun encode(bytes: ByteArray): String {
        if (bytes.isEmpty()) return ""
        val out = StringBuilder((bytes.size + 2) / 3 * 4)
        var i = 0
        while (i + 2 < bytes.size) {
            val n = ((bytes[i].toInt() and 0xff) shl 16) or
                ((bytes[i + 1].toInt() and 0xff) shl 8) or
                (bytes[i + 2].toInt() and 0xff)
            out.append(TABLE[(n shr 18) and 63])
            out.append(TABLE[(n shr 12) and 63])
            out.append(TABLE[(n shr 6) and 63])
            out.append(TABLE[n and 63])
            i += 3
        }
        when (bytes.size - i) {
            1 -> {
                val n = (bytes[i].toInt() and 0xff) shl 16
                out.append(TABLE[(n shr 18) and 63])
                out.append(TABLE[(n shr 12) and 63])
                out.append("==")
            }
            2 -> {
                val n = ((bytes[i].toInt() and 0xff) shl 16) or ((bytes[i + 1].toInt() and 0xff) shl 8)
                out.append(TABLE[(n shr 18) and 63])
                out.append(TABLE[(n shr 12) and 63])
                out.append(TABLE[(n shr 6) and 63])
                out.append('=')
            }
        }
        return out.toString()
    }

    fun decode(base64: String): ByteArray? {
        var clean = base64.trim().replace("\n", "").replace("\r", "").replace(" ", "")
        val dataIdx = clean.indexOf("base64,")
        if (dataIdx >= 0) clean = clean.substring(dataIdx + "base64,".length)
        if (clean.isEmpty()) return null
        val map = IntArray(128) { -1 }
        TABLE.forEachIndexed { idx, c -> map[c.code] = idx }
        val out = ArrayList<Byte>()
        var buffer = 0
        var bits = 0
        for (ch in clean) {
            if (ch == '=') break
            val v = if (ch.code < 128) map[ch.code] else -1
            if (v < 0) continue
            buffer = (buffer shl 6) or v
            bits += 6
            if (bits >= 8) {
                bits -= 8
                out.add(((buffer shr bits) and 0xff).toByte())
            }
        }
        return out.toByteArray()
    }
}
